import { Component, OnInit, ViewChild } from '@angular/core';
import { ClusterMaster } from 'src/app/Models/clustermaster';
import { ApiService } from 'src/app/Service/api.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-clustermasterlist',
  templateUrl: './clustermasterlist.component.html',
  styleUrls: ['./clustermasterlist.component.css']
})

export class ClustermasterlistComponent implements OnInit {
  formTitle = "Manage Clusters";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "ID";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
  columns: string[][] = [["NAME", "Cluster Name"], ["SHORT_CODE", "Short Code"], ["SEQUENCE_NO", "Sequence Number"]];
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: ClusterMaster = new ClusterMaster();
  applicationId = Number(this.cookie.get('applicationId'))
  drawerVisible1: boolean;
  drawerTitle1: string;
  drawerData1: ClusterMaster = new ClusterMaster();
  listOfData: ClusterMaster[] = [];
  OPEN_TIME2 = null;
  CLOSE_TIME2 = null;
  DAYS = false;

  constructor(private api: ApiService, private cookie: CookieService) { }

  ngOnInit() {
    this.search();
  }

  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);
  }

  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
      this.sortKey = "id";
      this.sortValue = "desc"
    }

    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";

    } catch (error) {
      sort = "";
    }

    var likeQuery = "";
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      likeQuery = " AND (";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });

      likeQuery = likeQuery.substring(0, likeQuery.length - 2) + ')'
      console.log("likeQuery" + likeQuery);
    }

    this.api.getAllclusterMaster(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery + ' AND  ORG_ID =' + this.cookie.get('orgId')).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];

      if (this.totalRecords == 0) {
        data.SEQUENCE_NO = 1;

      } else {
        data.SEQUENCE_NO = this.dataList[this.dataList.length - 1]['SEQUENCE_NO'] + 1
      }

    }, err => {
      console.log(err);
    });
  }

  get closeCallback() {
    return this.drawerClose.bind(this);
  }

  get closeCallback1() {
    return this.drawerClose1.bind(this);
  }

  add(): void {
    this.drawerTitle = "Create New Cluster";
    this.drawerData = new ClusterMaster();
    this.drawerData.ORG_ID = Number(this.cookie.get('orgId'));

    this.api.getAllclusterMaster(1, 1, 'SEQUENCE_NO', 'desc', ' AND  ORG_ID =' + this.cookie.get('orgId')).subscribe(data => {
      if (data['count'] == 0) {
        this.drawerData.SEQUENCE_NO = 1;

      } else {
        this.drawerData.SEQUENCE_NO = Number(data['data'][0]['SEQUENCE_NO']) + 1;
      }

    }, err => {
      console.log(err);
    })

    this.drawerVisible = true;
  }

  edit(data: ClusterMaster): void {
    this.drawerTitle = "Update Cluster";
    this.drawerData = Object.assign({}, data);
    this.OPEN_TIME2 = null;
    this.CLOSE_TIME2 = null;
    this.DAYS = false;
    this.drawerVisible = true;
  }

  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  drawerClose1(): void {
    this.drawerVisible1 = false;
  }
}